import { formatSentAt } from "@/utils/sendings";

// Messaggi inviati a un cliente (GET registries/{id}/communications): i log di
// LisaComunica collegati al cliente, da Quietanzamento, Titoli, analisi o Compleanni, nella forma
// delle righe della scheda Invii.

// Stati del log, come in Lisacomunica > Log
const LOG_STATUSES = {
  TEMP_FAILED: "Temporaneamente fallito",
  FAILED: "Fallito",
  OK: "Completato",
  DELIVERED: "Consegnato",
  OPENED: "Aperto",
  SCHEDULED: "Programmato",
};
// Stati di un messaggio partito: preso in carico, consegnato o aperto
const SENT_STATUSES = ["OK", "DELIVERED", "OPENED"];

const CHANNELS = { EMAIL: "Email", SMS: "SMS" };

export const logStatus = (value) => ({
  value,
  text: LOG_STATUSES[value] ?? "-",
});

export const channelLabel = (value) => CHANNELS[value] ?? value ?? "-";

/** Testo della riga sopra la tabella, come nella scheda Invii. */
export const lastSentLabel = (rows) => {
  const last = rows
    .filter((row) => SENT_STATUSES.includes(row.status) && row.sent_at)
    .reduce(
      (latest, row) => (!latest || row.sent_at > latest.sent_at ? row : latest),
      null
    );
  return last
    ? `Ultimo invio riuscito: ${formatSentAt(last.sent_at)}`
    : "Nessun invio riuscito";
};
